import {
  Button,
  Icons,
  Typography,
  Box,
  Stack,
  tokens,
} from '@cast/design-system';

import { CHAT_SUGGESTIONS } from './_constants';

type Props = {
  onSuggestionClick: (suggestion: string) => void;
};

export const EmptyState = ({ onSuggestionClick }: Props) => {
  return (
    <Stack flex={1} alignItems="center" justifyContent="center" p={24}>
      <Stack gap={24}>
        <Stack gap={12} alignItems="center">
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: 64,
              width: 64,
              background: tokens.theme.bg.categorical.blueStrong,
              borderRadius: '50%',
            }}
          >
            <Icons.CastCopilot
              size={37}
              color={tokens.theme.fg.categorical.onBlueStrong}
            />
          </Box>
          <Stack gap={8} textAlign="center">
            <Typography variant="h5" data-testid="chat-empty-state-greeting">
              Hi, how can I help?
            </Typography>
            <Typography
              maxWidth="430px"
              variant="P14R"
              color={tokens.theme.fg.structural.secondary}
            >
              Ask me about your clusters, workloads, or costs — I&apos;ll
              analyze your setup, surface insights, and show what impacts
              performance and spend.
            </Typography>
          </Stack>
        </Stack>
        <Stack>
          {CHAT_SUGGESTIONS.map((suggestion) => (
            <Button
              fullWidth
              sx={{
                textWrap: 'wrap',
                justifyContent: 'space-between',
                p: 12,
                minHeight: '46px',
                borderBottom: '1px solid',
                borderBottomColor: tokens.theme.border.structural.neutralSubtle,
                borderRadius: 0,
              }}
              key={suggestion}
              variant="ghost"
              endIcon={<Icons.ArrowRight size={16} />}
              onClick={() => {
                onSuggestionClick(suggestion);
              }}
            >
              <Typography variant="P14M">{suggestion}</Typography>
            </Button>
          ))}
        </Stack>
      </Stack>
    </Stack>
  );
};
